import { Link } from "react-router-dom";
import SectionTitle from "../components/SectionTitle";
import { motion, easeInOut } from "framer-motion";

const sectionVariants = {
  hidden: { opacity: 0, y: 30, scale: 0.98 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 0.4, ease: easeInOut },
  },
};

const floatingShapeVariants = {
  animate: {
    y: [0, -10, 0],
    x: [0, 10, 0],
    transition: { repeat: Infinity, duration: 3, ease: "easeInOut" as const },
  },
};

export default function AnimatedRentalSection() {
  return (
    <motion.div
      style={{
        maxWidth: "900px",
        margin: "3rem auto",
        padding: "2.5rem",
        borderRadius: "20px",
        position: "relative",
        overflow: "hidden",
        background: "linear-gradient(180deg, #ffffff 0%, #f0f8ff 100%)",
        boxShadow: "0 8px 32px rgba(27,90,122,0.12)",
        textAlign: "center",
      }}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: false, amount: 0.1 }}
      variants={sectionVariants}
    >
      {/* Floating shapes for parallax effect */}
      <motion.div
        style={{
          position: "absolute",
          width: 180,
          height: 180,
          borderRadius: "50%",
          background: "rgba(71,195,247,0.15)",
          top: "-40px",
          left: "-30px",
        }}
        variants={floatingShapeVariants}
        animate="animate"
      />
      <motion.div
        style={{
          position: "absolute",
          width: 120,
          height: 120,
          borderRadius: "50%",
          background: "rgba(20,103,108,0.12)",
          bottom: "-20px",
          right: "-50px",
        }}
        variants={floatingShapeVariants}
        animate="animate"
      />

      {/* Heading */}
      <motion.div
        style={{ marginBottom: "1rem" }}
        variants={{
          hidden: { opacity: 0, y: 20 },
          visible: {
            opacity: 1,
            y: 0,
            transition: { delay: 0.05, duration: 0.3 },
          },
        }}
      >
        <span style={{ fontSize: "2rem" }}>🏢</span>
      </motion.div>

      <motion.div
        variants={{
          hidden: { opacity: 0, y: 15 },
          visible: {
            opacity: 1,
            y: 0,
            transition: { delay: 0.1, duration: 0.3 },
          },
        }}
      >
        <SectionTitle
          parts={[
            { text: "RENTAL", color: "#143C5D" },
            { text: "SPACES", color: "#47C3F7" },
          ]}
        />
      </motion.div>

      {/* Paragraph */}
      <motion.p
        style={{ fontSize: "1.15rem", color: "#222", marginBottom: "1.5rem" }}
        variants={{
          hidden: { opacity: 0, y: 15 },
          visible: {
            opacity: 1,
            y: 0,
            transition: { delay: 0.15, duration: 0.3 },
          },
        }}
      >
        Need a venue for your next event, workshop, or gathering? Explore our
        flexible, modern rental spaces!
      </motion.p>

      {/* Button */}
      <motion.div
        variants={{
          hidden: { opacity: 0, scale: 0.97 },
          visible: {
            opacity: 1,
            scale: 1,
            transition: { delay: 0.2, duration: 0.3 },
          },
        }}
      >
        <Link
          to="/rental-spaces"
          style={{
            display: "inline-block",
            background: "#14676c",
            color: "#fff",
            padding: "0.7em 2em",
            borderRadius: "999px",
            fontWeight: 600,
            textDecoration: "none",
            fontSize: "1.08rem",
            boxShadow: "0 2px 12px rgba(27,90,122,0.13)",
            transition: "background 0.2s",
          }}
        >
          Explore Rental Spaces
        </Link>
      </motion.div>
    </motion.div>
  );
}
